var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2682_15300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99565 18C13.9285 18 18 13.9265 18 9C18 4.0735 13.9198 0 8.98695 0C4.06283 0 0 4.0735 0 9C0 13.9265 4.07153 18 8.99565 18ZM8.99565 16.207C5.00242 16.207 1.80957 12.9952 1.80957 9C1.80957 5.00484 5.00242 1.80174 8.98695 1.80174C12.9802 1.80174 16.1904 5.00484 16.1991 9C16.2078 12.9952 12.9889 16.207 8.99565 16.207ZM4.61092 10.0967H8.98695C9.38714 10.0967 9.69164 9.79207 9.69164 9.40039V3.70793C9.69164 3.31625 9.38714 3.01161 8.98695 3.01161C8.60416 3.01161 8.29966 3.31625 8.29966 3.70793V8.70406H4.61092C4.21943 8.70406 3.91493 9.0087 3.91493 9.40039C3.91493 9.79207 4.21943 10.0967 4.61092 10.0967Z",
    fill: "#1D1D1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_15300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b8adae53141f62753676d0fbd41e9723.svg";
export { ForwardRef as ReactComponent };